import { wizardFormBuilderPreloadDataAdapter } from './wizardFormBuilderPreloadDataAdapter';

const wizardPreloadDataAdaptersMapping = (preloadedDataAdapterName?: string) => {
  switch (preloadedDataAdapterName) {
    default:
      return wizardFormBuilderPreloadDataAdapter;
  }
};

export { wizardPreloadDataAdaptersMapping };
